module.exports = __webpack_public_path__ + "static/media/fm-icons-Right_arrow.405cc8c4.svg";